const externalLinks = {
    youtube: 'https://www.youtube.com/channel/UC6KUxvgUxKxp-eJbPP1ChjQ/featured?view_as=subscriber',
    facebook: 'https://www.facebook.com/tonyandgloria/?ref=bookmarks',
    homeIntroVideo: 'https://www.youtube.com/embed/-FbtfDw3oHY',
    classes: [
        'https://www.youtube.com/embed/eLsmh8EmrK8',
        'https://www.youtube.com/embed/hpNvpuJjrVM',
        'https://www.youtube.com/embed/Sa5QTO2_0GE',
        'https://www.youtube.com/embed/JafFKnJbq30',
        'https://www.youtube.com/embed/2GMV98R_ODw',
        'https://www.youtube.com/embed/mytF7Y9jhSQ',
    ],
    emailTo: "mailto:tonyandgloria@gmail.com",
    contactForm: "https://us17.list-manage.com/contact-form?u=9426f692adf3fa5f57adaffbf&form_id=b2b694804b35278da1cd14fe8b8338ac",
};

export default externalLinks;